import React from "react";
import Link from "gatsby-link";
// import ClassNames from 'classnames'

class Intro extends React.Component {
  constructor(props) {
    super(props);
    this.escapeHTML = this.escapeHTML.bind(this);
  }

  escapeHTML(html) {
    return {
      __html: html
    };
  }

  render() {
    return (
      <div id="Intro" className="Intro">
        <div className="internal">
          <div
            className="copy"
            dangerouslySetInnerHTML={this.escapeHTML(this.props.intro)}
          />
          <Link to="/buy" className="Btn orange-white">
            {this.props.callToAction}
          </Link>
        </div>
        <div className="bg" />
      </div>
    );
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/home/intro.js